<div
  [formGroup]="learningCenterForm"
  id="second-section-input-container"
  class="card p-4"
>
  <h3 style="font-weight: 700; color: #060e9f">
    รายละเอียดส่วนที่ 2<lifedi-require></lifedi-require>
  </h3>
  <nz-form-control nzErrorTip="โปรดระบุ">
  <div
    [ngClass]="{
      error:
        CONTENT2_DETAIL.invalid &&
        CONTENT2_DETAIL.dirty
    }"
  >
    <angular-editor
      id="second-section-text-editor"
      placeholder="ใส่เนื้อหาบทความ"
      style="margin: 0 auto"
      [config]="editorConfig"
      formControlName="CONTENT2_DETAIL"
    >
    </angular-editor>
  </div>
</nz-form-control>
</div>
